<template>
  <div class="menu__sidemenu new" :style="[!sideViewYn ? {height: '5px'} : '']" v-if="sideList.length != 0 && optionItemList.length != 0">
    <button class="btn-open-side" @mouseup="sideViewYn = !sideViewYn" :class="{close: !sideViewYn}">
      <i></i><span>{{ $t('Modal.MenuPersonal.msg21') }}</span>
    </button>
    <div class="box-bdr">
      <div class="box-bdr__head">{{ $t('Modal.MenuPersonal.msg3') }}</div>
      <div class="tab-round">
        <button class="tab tab-sm btn-anim" @mouseup="selectOptionCd = 'A'" :class="{on: 'A' === selectOptionCd}">
          {{ $t('Modal.MenuPersonal.msg4') }}
        </button>
        <button
          class="tab tab-sm btn-anim"
          @mouseup="selectOptionCd = side.OPT_CLAS_CD"
          :class="{on: side.OPT_CLAS_CD === selectOptionCd}"
          v-for="side in sideList"
          :key="side"
        >
          {{ side.OPT_CLAS_NM }}
        </button>
      </div>
      <div class="swiper-wrap">
        <div id="sideMenuScroll" class="scroll-area">
          <!-- one item -->
          <div
            class="swiper-slide"
            v-for="option in optionItemList.filter((item) => (selectOptionCd == 'A' ? true : item.OPT_CLAS_CD === selectOptionCd))"
            :key="option"
          >
            <div class="touchbox-wrap">
              <div style="display: block" class="touchbox--option btn--shadow" @mouseup="optionQtyChange(option, 1)">
                <div class="col__img">
                  <img
                    :src="
                      option.OPT_ITEM_IMG_FILE_URL.length == null || option.OPT_ITEM_IMG_FILE_URL.length == 0
                        ? option.ITEM_IMG_FILE_URL
                        : option.OPT_ITEM_IMG_FILE_URL
                    "
                    alt=""
                    @error="replaceToDefaultImg"
                  />
                </div>
                <div class="col__txt">
                  <div class="ellipsis-m">
                    <span class="ft--xsm">{{ option.PRESET_NM }}</span>
                  </div>
                  <span class="ft--lg ft--bold">{{ $displayUprc($detailUprc(option)) }}</span>
                </div>
              </div>
              <div class="count-num">
                <button class="btn-touch60 btn-anim" @mouseup="optionQtyChange(option, -1)">
                  <span class="btn-minus--mini" :class="{off: option.SALES_QTY <= 0}" :style="[option.SALES_QTY <= 0 ? {'box-shadow': 'none'} : '']">빼기</span>
                </button>
                <span class="txt-btwbtn">{{ option.SALES_QTY }}</span>
                <button class="btn-touch60 btn-anim" @mouseup="optionQtyChange(option, 1)">
                  <span class="btn-plus--mini">더하기</span>
                </button>
              </div>
            </div>
          </div>
          <!-- //one item -->
        </div>
        <button class="btn-arr-l btn--sm btn-anim" @mouseup="scrollMove(-300)">좌</button>
        <button class="btn-arr-r btn--sm btn-anim" @mouseup="scrollMove(300)">우</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sideMenu',
  props: {
    sideMenuYn: Boolean,
    itemObj: Object,
    optionCnt: Number,
  },
  methods: {
    // 상품 이미지 로딩 실패 시 기본 이미지 표시
    replaceToDefaultImg(e) {
      e.target.src = require('@/assets/images/common/no-image.png');
    },
    //옵션 수량 변경
    optionQtyChange(option, num) {
      if (num == -1 && option.SALES_QTY == 0) return false;
      if (num == 1 && option.SALES_QTY == 99) return false;
      if (num == 1) option.SALES_QTY++;
      if (num == -1) option.SALES_QTY--;

      let opt = Object.assign({}, option);
      this.$emit('sideBasket', opt, num);
    },
    //사이드 상품 조회
    async getSide() {
      let data = JSON.parse(JSON.stringify(this.tbMstOpt.filter((item) => item.OPT_GRP_CD == this.itemObj.OPT_GRP_CD && item.OPT_GBN == '03' )));

      data.forEach((item)=>{
        let OPT_CLAS_CD = item.OPT_CLAS_CD;
        let optionItemList = JSON.parse(JSON.stringify(this.tbMstItem.filter((item2) => item2.OPT_CLAS_CD == OPT_CLAS_CD)));
        item.optionItemList = optionItemList;
      })
      
      this.sideList = data;
      if (this.sideList.length == 0) return;
      
      if (this.$i18n.locale == 'jp') {
        this.sideList.forEach((item) => {
          item.OPT_CLAS_NM = item.OPT_CLAS_JP_NM;
          item.optionItemList.forEach((item2) => {
            item2.PRESET_NM = item2.PRESET_NM_JP;
          });
        });
      } else if (this.$i18n.locale == 'ko') {
        this.sideList.forEach((item) => {
          item.OPT_CLAS_NM = item.OPT_CLAS_KO_NM;
          item.optionItemList.forEach((item2) => {
            item2.PRESET_NM = item2.PRESET_NM_KO;
          });
        });
      } else if (this.$i18n.locale == 'en') {
        this.sideList.forEach((item) => {
          item.OPT_CLAS_NM = item.OPT_CLAS_EN_NM;
          item.optionItemList.forEach((item2) => {
            item2.PRESET_NM = item2.PRESET_NM_EN;
          });
        });
      } else if (this.$i18n.locale == 'cn') {
        this.sideList.forEach((item) => {
          item.OPT_CLAS_NM = item.OPT_CLAS_CN_NM;
          item.optionItemList.forEach((item2) => {
            item2.PRESET_NM = item2.PRESET_NM_CN;
          });
        });
      } else if (this.$i18n.locale == 'tw') {
        this.sideList.forEach((item) => {
          item.OPT_CLAS_NM = item.OPT_CLAS_TW_NM;
          item.optionItemList.forEach((item2) => {
            item2.PRESET_NM = item2.PRESET_NM_TW;
          });
        });
      }
      
      this.sideList.forEach((item) => {
        item.optionItemList.forEach((list) => {
          this.optionItemList.push(list);
        });
      });    
    },
    scrollMove(num) {
      document.querySelector('#sideMenuScroll').scrollLeft += num;
    },
  },
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      selectOptionCd: 'A',
      sideList: [],
      optionItemList: [],
      sideViewYn: false,
      tbMstOpt : this.$store.getters.getTbMstOpt,
      tbMstItem : this.$store.getters.getTbMstItem,
    };
  },
  mounted() {
    this.getSide();
  },
  components: {},
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    optionCnt(val) {
      if (val < 2) this.sideViewYn = true; // HSSHIN 옵션이 2개 이상에만 열리도록 수정
    },
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    async sideMenuYn(yn) {
      if (yn) {
        this.getSide();
      }
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/menu.css" scoped></style>
<style src="@/assets/css/user/pages/touchbox.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/menu-dark.css" scoped></style>
.
<style src="@/assets/css/user/dark/touchbox-dark.css" scoped></style>
<style scoped>
.menu__sidemenu .swiper-wrap .btn-arr-l {
  left: 16px;
}

.menu__sidemenu .swiper-wrap .btn-arr-r {
  right: 16px;
}

.ft--xsm {
  font-size: 1.0em;
}

.ft--lg {
  font-size: 1.3em;
}

.txt-btwbtn {
  font-size: 1.4em;
}

@media (-webkit-device-pixel-ratio: 1.25) {
	.count-num {
    margin : 12px 0px;
  }

  .touchbox--option {
    width: 18.7vw;
    height: 13.4vh;
  }

  .menu__sidemenu .tab-round{
    margin : 12px var(--txt-pd40);
  }

  .menu__sidemenu .swiper-wrap .btn-arr-l,
  .menu__sidemenu .swiper-wrap .btn-arr-r {
    top: 60px;
  }
}

@media (-webkit-device-pixel-ratio: 1.1) {
	.count-num {
    margin : 6px 0px;
  }
  
  .touchbox--option {
    width: 17.7vw;
    height: 11.3vh;
  }

  .menu__sidemenu .tab-round{
    margin : 12px var(--txt-pd40);
  }

  .menu__sidemenu .swiper-wrap .btn-arr-l,
  .menu__sidemenu .swiper-wrap .btn-arr-r {
    top: 60px;
  }
}
</style>
